import React, { useEffect, useState } from "react";
import axios from "axios";
import "./Speaker.css";

const Speakers = () => {
  const [speakers, setSpeakers] = useState([]);

  useEffect(() => {
    fetchSpeakers();
  }, []);

  const fetchSpeakers = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_SERVER_URL}/api/v1/admin/speakers`
      );
      setSpeakers(response.data);
    } catch (error) {
      console.error("Error fetching speakers:", error);
    }
  };

  const renderSpeakerSection = (title, type) => {
    const filteredSpeakers = speakers.filter((s) => s.type === type);

    return (
      <div className="speaker-section">
        <div className="sectionTitle">
        <h2 className="section-title">{title}</h2>
        </div>
        <div className="speaker-grid">
          {filteredSpeakers.length > 0 ? (
            filteredSpeakers.map((speaker, index) => (
              <div key={index} className="speaker-card">
                <div className="img-container">
                  <img
                    className="speaker-image"
                    src={speaker.picture || '/default-avatar.jpg'}
                    alt={speaker.name}
                  />
                </div>
                <div className="speaker-details">
                  <h3 className="speaker-name">{speaker.name}</h3>
                  <p className="speaker-meta">
                    {speaker.position}
                    <br />
                    {speaker.university}
                  </p>
                  {speaker.website && (
                    <a href={speaker.website} className="speaker-link">
                      Visit Website
                    </a>
                  )}
                  {speaker.abstract && (
                    <div className="talk-title">
                      <strong>Title:</strong>
                      <p>{speaker.abstract}</p>
                    </div>
                  )}
                </div>
              </div>
            ))
          ) : (
            <p className="no-speakers">No {title} available.</p>
          )}
        </div>
      </div>
    );
  };

  return (
    <div className="speakers-container">
      {renderSpeakerSection("Keynote Speakers", "KeynoteSpeaker")}
      {renderSpeakerSection("Invited Talks", "InvitedTalks")}
    </div>
  );
};

export default Speakers;